module.exports = __webpack_public_path__ + "img/settings.04ede184.svg";